import { GetterTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { getResource } from '~/utils/store'
import { ApplicationSubmission, ApplicationSubmissionsState, ApplicationSubmissionResource } from './submissions.types'

const getters: GetterTree<ApplicationSubmissionsState, RootState> = {
  submissions (state, getters, rootState, rootGetters): ApplicationSubmission[] {
    return Object.values(state.data).map(({ id }) => getResource<ApplicationSubmissionResource>(state, id, rootGetters))
  },

  submissionById (state) {
    return (attachmentId: string) => {
      return getResource<ApplicationSubmissionResource>(state, attachmentId)
    }
  }
}

export default getters
